(function () {

  document.addEventListener('DOMContentLoaded', function () {
    var links = document.querySelectorAll('a.e-preventdefault');
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
      });
    });
  });

})();
